module.exports = __webpack_public_path__ + "img/xl-bg.b6ec0049.jpg";